<template>
  <li>
    <div class="row">
      <div class="col-12 col-lg-6 col-xl-4 d-flex align-items-center">
        <p>
          <span class="data-label d-xl-none">Graduate Name</span>
          {{ graduate.name }}
          <span class="d-block small">{{ graduate.email }}</span>
        </p>
      </div>

      <div class="col-6 col-lg-6 col-xl-2 d-flex align-items-center">
        <p class="text-muted">
          <span class="data-label d-xl-none">GEN</span>
          {{ graduate.gen | nullable }}
        </p>
      </div>

      <div class="col-6 col-lg-6 col-xl-6">
        <multiselect
          v-model="managerSelected"
          placeholder
          :options="managersAlpha"
          :disabled="true"
          :searchable="true"
          :internal-search="false"
          @search-change="debouncedSearch"
          @select="managerWasSelected"
          track-by="id"
          :allow-empty="false"
          :show-labels="false"
          name="manager"
          v-validate="'required'"
          :class="[errorClass('manager')]"
        >
          <template slot="noResult">
            Could not find any managers for your search.
          </template>
          <template slot="noOptions">
            There are no managers.
          </template>
          <template slot="afterList">
            <lazy-loading
              :loading="searchingManagers"
              :reached-bottom="getNextManagers"
              scroll-target=".multiselect__content-wrapper"
              ref="lazy">
              <span slot="loading"></span>
              <span slot="finished"></span>
            </lazy-loading>
          </template>
          <template slot="singleLabel" slot-scope="{ option }">
            <span class="dual-line">
              {{ option.name }}
              <br>
              <span class="secondary">{{ option.email }}</span>
            </span>
          </template>

          <template slot="option" slot-scope="{ option }">
            <span class="dual-line">
              {{ option.name }}
              <br>
              <span class="secondary">{{ option.email }}</span>
            </span>
          </template>
        </multiselect>

        <help-block field="manager"/>
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { managerComputed, managerMethods, programGraduateMethods } from 'vx/helpers'
import { handleServerErrors } from 'utils'
import { debounce } from 'lodash'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    graduate: {
      required: true,
      type: Object
    },
    placement: {
      required: true,
      type: Object
    },
    agencySelected: {
      required: true,
      type: Object
    }
  },

  components: {
    Multiselect
  },

  data () {
    return {
      managerSelected: null,
      search: null,
      searchingManagers: false
    }
  },

  computed: {
    ...managerComputed
  },

  created () {
    this.managerSelected = this.placement ? this.placement.manager : null
  },

  methods: {
    ...managerMethods,
    ...programGraduateMethods,

    debouncedSearch: debounce(async function (search) {
      this.searchingManagers = true

      this.search = search

      await this.getManagers({ params: { search, agency: this.agencySelected.id } })

      this.$refs.lazy.$emit('reset')

      this.searchingManagers = false
    }, 800),

    async getNextManagers () {
      await this.getManagers({ params: { search: this.search, agency: this.agencySelected.id }, next: true })
    },

    async managerWasSelected (manager) {
      try {
        await this.updateManagerAssignment({
          manager,
          graduate: this.graduate,
          placement: this.placement
        })

        this.$noty.success(`Manager assignment has been updated for ${this.graduate.name}.`)
      } catch (error) {
        this.managerSelected = this.placement ? this.placement.manager : null

        if (error.response) {
          if (error.response.status === 422) {
            handleServerErrors(error, this.$validator)
          } else if (error.response.status === 400) {
            this.$noty.error(error.response.data.message)
          }
        }
      }
    }
  }
}
</script>
